import React from "react"

//styles
import { Container } from "./scrollToTopButton.styles"

export default class ScrollToTopButton extends React.Component {
  constructor() {
    super()
    this.state = {
      is_visible: false,
    }
  }

  toggleVisibility() {
    if (this.topButton && window.pageYOffset > 300) {
      this.setState({
        is_visible: true,
      })
    } else if (this.topButton) {
      this.setState({
        is_visible: false,
      })
    }
  }

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    })
  }

  componentDidMount() {
    window.addEventListener("scroll", () => {
      this.toggleVisibility()
    })
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", () => {
      this.toggleVisibility()
    })
  }

  render() {
    const { is_visible } = this.state
    return (
      <Container
        onClick={() => this.scrollToTop()}
        onKeyDown={e => (e.key === 13 ? this.scrollToTop() : null)}
        aria-label="Zurück nach oben"
        active={this.state.is_visible}
        ref={topButton => (this.topButton = topButton)}
      >
        {is_visible && (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="35"
            height="32"
            viewBox="0 0 35 32"
          >
            <g transform="translate(-16867.879 -13.997)">
              <g transform="translate(16849.758 10.634)">
                <rect
                  id="rect"
                  width="35"
                  height="31.999"
                  rx="4.928"
                  transform="translate(18.121 3.364)"
                  opacity="0.35"
                />
                <g transform="translate(18.121 3.363)">
                  <rect
                    id="rect"
                    width="35"
                    height="31.999"
                    rx="4.928"
                    fill="rgba(0,0,0,0)"
                  />
                </g>
              </g>
              <path
                d="M24.494,86.615,13.21,75.33a1.128,1.128,0,0,0-1.6,0L.33,86.615a1.128,1.128,0,0,0,1.6,1.6L12.412,77.724,22.9,88.211a1.128,1.128,0,0,0,1.6-1.6Z"
                transform="translate(16873.176 -52)"
                fill="#fff"
              />
            </g>
          </svg>
        )}
      </Container>
    )
  }
}
